import type { ComponentType, CSSProperties } from 'react';
import * as iconsList from './Icons';

type IconName = keyof typeof iconsList;
type IconsProps = {
  icon: IconName | string;
  size?: number;
  color?: string;
  fill?: string;
  customStyle?: CSSProperties;
};

export const Icons = ({ icon, size = 16, color = '', fill = '', customStyle = {} }: IconsProps) => {
  if (!icon) {
    return null;
  }

  const style = {
    display: 'flex',
    color: color ? color : 'var(--primary-color)',
    fill: fill ? fill : '',
    height: `${size}px`,
    width: `${size}px`,
    ...customStyle,
  };

  const iconsMap = iconsList as Record<string, ComponentType<{ style?: CSSProperties; color?: string }>>;
  const IconComponent = iconsMap[String(icon) as string];
  return IconComponent ? <IconComponent color={color} style={style} /> : null;
};
